module.exports = __webpack_public_path__ + "static/media/no-villas-found-icon.ab8c72cd.svg";